export const ipAddressWhitelistApplications = {
  BO: 'Dashboard',
  directkit: 'API'
};
